module.exports = "/_next/static/images/Hero@2x-8a492cab628f4003af24b60a39fb0342.png";